// extracted by mini-css-extract-plugin
module.exports = {"photo":"Photo_photo__388PE","files":"Photo_files__22u2x","preview":"Photo_preview__2CRZm"};